import { render } from "./bars-menu.vue?vue&type=template&id=38600084"
const script = {}

import exportComponent from "/builds/portal-da-transparencia/cge-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__